const localStorageMiddleware = (store) => (next) => (action) => {
  let result = next(action);

  if (action.type.includes("auth")) {
    const currentState = store.getState();
    const user = currentState.auth.user;
    if (user) {
      localStorage.setItem("currentUser", JSON.stringify(user));
    } else {
      localStorage.removeItem("currentUser");
    }
  }
  return result;
};

export default localStorageMiddleware;
